import { ReactNode } from "react";

const urlRegex = /(\bhttps?:\/\/[^\s]+|\bwww\.[^\s]+)/gi;

export function parseLinks(text: string): ReactNode[] {
  if (!text) return [];
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = urlRegex.exec(text)) !== null) {
    const [url] = match;
    const start = match.index;

    if (start > lastIndex) nodes.push(text.slice(lastIndex, start));

    const href = url.startsWith("http") ? url : `https://${url}`;

    nodes.push(
      <a
        key={`link-${nodes.length}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1a73e8", textDecoration: "underline" }}
      >
        {url}
      </a>
    );

    lastIndex = start + url.length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));

  return nodes;
}
